export const OfficeSearchButtonComponent = {
	transclude: true,
	templateUrl: 'office-search-button.html',
	controller: class OfficeSearchButtonComponent {
		constructor() {
		}

		officeSearch($event) {
			$event.preventDefault();
			$event.stopPropagation();
			setTimeout(() => {
				window.location.href = angular.element($event.currentTarget).attr('data-link');
			}, 500);
		}
	}
};
